/**
 * External Dependencies
 */
//import 'jquery';
import "@lottiefiles/lottie-player";
import "select2";

(function($) {
	let clearspace = document.getElementById('toggleit');
  let togglefilter = document.getElementById('togglefilter');
  let togglegrid = document.getElementById('togglegrid');
  let mainmenu = document.getElementById('mainmenu');
  let intViewportHeight = window.innerHeight;
  let navigation = document.getElementById('primary');
  let navcover = document.getElementById('nav-cover');
  let closenav = document.getElementById('close');
  let fylkePrimaer = document.getElementById('fylke-primaer');
  let fylkeSekundaer = document.getElementById('fylke-sekundaer');

  if (mainmenu) {
    mainmenu.addEventListener('click', function() {
    mainmenu.classList.toggle('is-active');
    navigation.classList.toggle('is-active');
    navcover.classList.toggle('hidden');

    if (mainmenu.classList.contains('is-active')) {
      mainmenu.setAttribute('aria-expanded', 'true');
    } else {
      mainmenu.setAttribute('aria-expanded', 'false');
    }
  });
  }

  if (closenav) {
    closenav.addEventListener('click', function() {
    mainmenu.classList.toggle('is-active');
    navigation.classList.toggle('is-active');
    navcover.classList.toggle('hidden');

    if (mainmenu.classList.contains('is-active')) {
      mainmenu.setAttribute('aria-expanded', 'true');
    } else {
      mainmenu.setAttribute('aria-expanded', 'false');
    }
  });
  }

  if (navcover) {
    navcover.addEventListener('click', function() {
    mainmenu.classList.toggle('is-active');
    navigation.classList.toggle('is-active');
    navcover.classList.toggle('hidden');

    if (mainmenu.classList.contains('is-active')) {
      mainmenu.setAttribute('aria-expanded', 'true');
    } else {
      mainmenu.setAttribute('aria-expanded', 'false');
    }
  });
  }

	// $ Works! You can test it with next line if you like
	console.log($);

  if (clearspace) {
    $(clearspace).on("click", function() {
      let clearspaceImage = $('.clearspaceimage');
      var src = (clearspaceImage.attr("src") === clearspaceImage.attr('data-togglesrc2')) ? clearspaceImage.attr('data-togglesrc1') : clearspaceImage.attr('data-togglesrc2');
      $(clearspaceImage).attr("src", src);
    });
  }

  if (togglefilter) {
    $(togglefilter).on("click", function() {
      let togglefilterImage = $('.togglefilterimage');
      var src = (togglefilterImage.attr("src") === togglefilterImage.attr('data-togglesrc2')) ? togglefilterImage.attr('data-togglesrc1') : togglefilterImage.attr('data-togglesrc2');
      $(togglefilterImage).attr("src", src);
    });
  }

  if (togglegrid) {
    $(togglegrid).on("click", function() {
      let togglegridImage = $('.togglegridimage');
      var src = (togglegridImage.attr("src") === togglegridImage.attr('data-togglesrc2')) ? togglegridImage.attr('data-togglesrc1') : togglegridImage.attr('data-togglesrc2');
      $(togglegridImage).attr("src", src);
    });
  }

  $(window).on("scroll", function() {
    if ($(this).scrollTop() > intViewportHeight) {
      $(mainmenu).fadeIn();
    }
  else {
     if ($(this).scrollTop() > intViewportHeight) {
      $(mainmenu).fadeIn();
     } else {
      $(mainmenu).fadeOut();
     }
  }

  });

  $('.has-dropdown').on("click", function(e) {
    e.preventDefault();
    $(this).find('.listtoggle').toggleClass('rotate-180');
    $(this).siblings('.submenu').toggleClass('hidden');
  });

    $('#fylker').select2({
      placeholder: 'Velg fylke',
    });
    $('#fylker').on('select2:select', function (e) {
      let primaer = $('#fylker option:selected').attr('data-primaer');
      let sekundaer = $('#fylker option:selected').attr('data-sekundaer');
      let downloadBtn = $('#fylkeslogodownload');
      let downloadUrl = $('#fylker option:selected').attr('data-primaerurl');

      fylkePrimaer.src = primaer;
      fylkeSekundaer.src = sekundaer;
      $(downloadBtn).attr("href", downloadUrl);
      $(downloadBtn).text('Last ned logoer for ' + $('#fylker').select2().val());
    });  
	
})( jQuery );
